import React from 'react';
import { AnalyticsAttributesProvider, Markdown } from '../../components';
import { StyledMarkdown } from './UiMarkdown.styled';
export default function UiMarkdown({ model }) {
    const { content, entryTitle, orderedListAppearance, textSize } = model.content;
    return (React.createElement(AnalyticsAttributesProvider, { value: {
            eventContainer: model.type,
            labelEnglish: entryTitle
        } },
        React.createElement(StyledMarkdown, { orderedListAppearance: orderedListAppearance, textSize: textSize },
            React.createElement(Markdown, null, content))));
}
//# sourceMappingURL=UiMarkdown.js.map